import NotificationView from './NotificationView';

export default NotificationView;
